import {
  BarChart3,
  Calendar,
  CheckCircle,
  Euro,
  ListChecks,
  Users,
} from "lucide-react";
import { Kpi } from "./interfaces";

export const kpis: Kpi[] = [
  {
    title: "Leads",
    value: "124",
    icon: Users,
    change: "+12% zum Vormonat",
  },
  {
    title: "Termine",
    value: "45",
    icon: Calendar,
    change: "+5% zum Vormonat",
  },
  {
    title: "Aufträge",
    value: "28",
    icon: ListChecks,
    change: "+18% zum Vormonat",
  },
  {
    title: "AE",
    value: "21",
    icon: CheckCircle,
    change: "+2% zum Vormonat",
  },
  {
    title: "Provision AE",
    value: "€45.231",
    icon: BarChart3,
    change: "+10% zum Vormonat",
  },
  {
    title: "Provision Abgerechnet",
    value: "€32.845",
    icon: Euro,
    change: "+15% zum Vormonat",
  },
];
